import React from 'react'
import { MegaMenuItem } from './types'
import { MenuItem } from '@/ui/layout/Header/NavBar/MegaMenu/MenuItem'
import { CMSImage } from '@/ui/atoms/CMSImage'
import { LabelClickable } from '@/ui/atoms/LabelClickable'
import { useTranslations } from 'next-intl'
import { removeLangFromPath } from '@/utils/removeLangFromPath'

type DetailPanelProps = {
  link: MegaMenuItem['categories'][0]['links'][0] | null
  currentPath: string
  onLinkClick: () => void
}

export const DetailPanel: React.FC<DetailPanelProps> = ({ link, currentPath, onLinkClick }) => {
  const t = useTranslations('megaMenu')
  if (!link) return null

  return (
    <div
      className={
        'p-5 animate-in fade-in-0 border rounded-md border-border-subtle lg:w-[400px] min-w-[250px] ' +
        (link.isComingSoon ? 'invisible' : 'visible')
      }
    >
      <div className={'h-full min-h-[400px] flex flex-col justify-between gap-6 xl:gap-8'}>
        <div>
          <h4 className="text-label-XS-regular text-text-faded mb-5">{t('coreStages')}</h4>
          <ul className="space-y-0">
            {link.extraContents?.items ? (
              link.extraContents.items.map((item, idx) => (
                <li key={idx}>
                  <LabelClickable
                    inverted={false}
                    title={item.label}
                    icon={item.iconName}
                    className={
                      '!bg-transparent !backdrop-blur-none [&>*]:hover:underline [&>div>svg]:hover:!text-text-base [&>*]:hover:!text-text-base flex flex-row gap-2 !px-0 [&>div>svg]:text-text-faded [&>*]:text-text-faded ' +
                      (removeLangFromPath(currentPath) === removeLangFromPath(item.href) &&
                        ' [&>div>svg]:!text-text-base [&>*]:!text-label-XS-semibold [&>*]:!text-text-base')
                    }
                    href={item.href}
                  />
                </li>
              ))
            ) : (
              <>
                <li>
                  <MenuItem link={link} isHovered={false} />
                </li>
                <li>
                  <MenuItem link={link} isHovered={false} />
                </li>
              </>
            )}
          </ul>
        </div>
        {link.extraContents?.image && (
          <CMSImage
            resource={link.extraContents.image}
            fill
            className="hidden lg:block !relative !w-auto min-w-52 max-h-56 !aspect-16/9 object-cover rounded-md"
          />
        )}
      </div>
    </div>
  )
}
